import { render, staticRenderFns } from "./ModalCommission.vue?vue&type=template&id=08f395d2&lang=pug"
import script from "./ModalCommission.vue?vue&type=script&lang=js"
export * from "./ModalCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports